import { useState } from "react";
import PreviewQandA from "./components/PreviewQandA";
import HandleCreateQuestion from "./HandleCreateQuestion";
import { QuationProps } from "../store/actionType";
import { VideoDetailProps } from "modules/video/video_detail/store/actionType";

interface Props {
  onClose: () => void;
  questionData: QuationProps[];
  videoData: VideoDetailProps;
}


const GetQuestion: React.FC<Props> = ({ onClose, questionData, videoData }) => {
  const [mode, setMode] = useState<"add" | "preview">("preview");

  const showCreate =
    mode === "add" || !questionData || questionData.length === 0;

  return (
    <div>
      <div className="flex justify-between items-center px-4 py-2 bg-primary-500 text-white mb-2 rounded-md">
        <h3 className="text-lg font-semibold">Question and Answer</h3>
        <div className="flex items-center justify-end gap-2">
          <div className="border px-2 py-1 text-xs rounded-md hover:border-primary-300 hover:text-primary-200 hover:shadow-md">
            <button onClick={() => setMode("add")}>Add</button>
          </div>
          {mode === "add" && (
            <div className="border px-2 py-1 text-xs rounded-md hover:border-primary-300 hover:text-primary-200 hover:shadow-md">
              <button onClick={() => setMode("preview")}>Preview</button>
            </div>
          )}
          {onClose && (
            <div className="border px-2 py-1 text-xs rounded-md hover:border-primary-300 hover:text-primary-200 hover:shadow-md">
              <button onClick={onClose}>✕</button>
            </div>
          )}
        </div>
      </div>
      {showCreate ? (
        <HandleCreateQuestion videoData={videoData} onClose={onClose} />
      ) : (
        <PreviewQandA
          videoData={videoData}
          questionData={questionData}
          onClose={onClose}
          setMode={setMode}
        />
      )}
    </div>
  );
};

export default GetQuestion;
